import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ChatQueueBanner({ position }) {
  const { t } = useTranslation();
  if (position == null) return null;

  return (
    <div className="px-3 py-1 text-xs text-amber-700 bg-amber-50 border-t border-amber-100">
      {t('chatbot.queued', 'Vous êtes en position {{position}} dans la file d\'attente', { position })}
    </div>
  );
}
